/* Nest & Nora exit offer (in-house, no app): one honest discount offer per visitor.
   Empty cart -> the "browse" offer (10%); items in the cart -> the "cart" offer (15%). Codes and wording live in
   snippets/nn-exit-offer.liquid. Shown at most once per visitor every 14 days, never on checkout or account pages, never
   when a discount is already applied. Desktop: the pointer leaves through the top of the window. Phones (no reliable
   "about to leave" signal, especially in Instagram's browser): a quick scroll back toward the top, or 45 s without a touch.
   No countdowns or fake urgency. */
(function () {
  var root = document.getElementById('nn-exit-offer');
  if (!root) return;
  var KEY = 'nnExitOffer.v1';
  var DAYS = 14;
  var start = Date.now();
  var minDelay = Number(root.getAttribute('data-min-delay') || 8) * 1000;

  function read() { try { return JSON.parse(window.localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function write(v) { try { window.localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* storage blocked: show at most once per page */ } }

  var seen = read();
  if (seen && Date.now() - seen.at < DAYS * 864e5) return;
  if (/^\/(checkout|checkouts|account|discount|cart\/c)/.test(location.pathname)) return;
  if (/(^|;\s*)discount_code=/.test(document.cookie)) return;

  var shown = false;
  var lastFocus = null;

  function cartCount() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c && c.item_count ? c.item_count : 0; })
      .catch(function () { return 0; });
  }

  function show(trigger) {
    if (shown || Date.now() - start < minDelay) return;
    shown = true;
    cartCount().then(function (n) {
      var kind = n > 0 ? 'cart' : 'browse';
      var bodies = root.querySelectorAll('[data-variant]');
      for (var i = 0; i < bodies.length; i++) bodies[i].hidden = bodies[i].getAttribute('data-variant') !== kind;
      root.setAttribute('aria-labelledby', 'nn-exit-title-' + kind);
      lastFocus = document.activeElement;
      root.hidden = false;
      window.requestAnimationFrame(function () { root.classList.add('is-open'); });
      write({ at: Date.now(), kind: kind, trigger: trigger });
      var cta = root.querySelector('[data-variant="' + kind + '"] .nn-exit__cta');
      if (cta) cta.focus({ preventScroll: true });
    });
  }

  function close() {
    root.classList.remove('is-open');
    window.setTimeout(function () { root.hidden = true; }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  root.addEventListener('click', function (e) {
    if (e.target === root || (e.target.closest && e.target.closest('[data-close]'))) close();
  });
  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') { // keep keyboard focus inside the dialog
      var f = root.querySelectorAll('[data-variant]:not([hidden]) a, [data-variant]:not([hidden]) button, .nn-exit__x');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // desktop: the pointer leaves through the top edge of the window
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY <= 0) show('exit');
  });

  // phones: a quick scroll back up toward the top, or a long idle
  if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
    var sampleY = window.scrollY, sampleT = Date.now();
    window.addEventListener('scroll', function () {
      var y = window.scrollY, t = Date.now();
      if (sampleY - y > 500 && t - sampleT < 900 && y < 700) show('scroll-up');
      if (t - sampleT > 300) { sampleY = y; sampleT = t; }
    }, { passive: true });
    var idle;
    var resetIdle = function () { window.clearTimeout(idle); idle = window.setTimeout(function () { show('idle'); }, 45000); };
    ['touchstart', 'scroll'].forEach(function (ev) { window.addEventListener(ev, resetIdle, { passive: true }); });
    resetIdle();
  }
})();
